import React, { FC } from "react";
export {
  List,
  ListItem,
  UnorderedList,
  OrderedList,
  ListIcon,
} from "@chakra-ui/layout";
export type { ListProps, ListItemProps } from "@chakra-ui/layout";

import { IconProps } from "@chakra-ui/icon";
import { Dot } from "../Icons/Dot";
import { ListIcon } from "@chakra-ui/layout";

export const ListBullet: FC<IconProps> = (props) => (
  <ListIcon
    as={Dot}
    w="5px"
    h="5px"
    position="relative"
    top="calc(0.5rem + 2.5px)"
    {...props}
  />
);
